import { render } from "./wordDetailTable.vue?vue&type=template&id=8f35135c&scoped=true"
import script from "./wordDetailTable.vue?vue&type=script&lang=js"
export * from "./wordDetailTable.vue?vue&type=script&lang=js"

import "./wordDetailTable.vue?vue&type=style&index=0&id=8f35135c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f35135c"]])

export default __exports__